import BadgesCell from "@/components/NewTable/BadgesCell";

export const columns = () => {
  return [
    {
      id: "code",
      accessorFn: (row) => `${row.code} - ${row.name}`,
      header: "Competition Group",
    },
    {
      id: "competitions",
      accessorFn: (row) => row.competitions,
      header: "Competition",
      enableSorting: false,
      cell: ({ row }) => <BadgesCell items={row.original.competitions} />,
    },
  ];
};
